import api from './api';
import {
  CreateVisitasDto,
  CreateVisitasPlanDto,
  PagedResult,
  ReordenarVisitasPlanDto,
  UpdateVisitasPlanDto,
  VisitasDto,
  VisitasPlanIndicadoresDto,
  VisitasPlanIndicadoresSearchDto,
  VisitasPlanDto,
  VisitasPlanSearchDto,
} from '../types/visitas';

const visitasPlanService = {
  getPlanes: async (params: VisitasPlanSearchDto): Promise<PagedResult<VisitasPlanDto>> => {
    const response = await api.get<PagedResult<VisitasPlanDto>>('/api/VisitasPlan', { params });
    return response.data;
  },

  getPlanesIndicadores: async (
    params: VisitasPlanIndicadoresSearchDto,
  ): Promise<PagedResult<VisitasPlanIndicadoresDto>> => {
    const response = await api.get<PagedResult<VisitasPlanIndicadoresDto>>('/api/VisitasPlanIndicadores', {
      params,
    });
    return response.data;
  },

  getPlan: async (id: number): Promise<VisitasPlanDto> => {
    const response = await api.get<VisitasPlanDto>(`/api/VisitasPlan/${id}`);
    return response.data;
  },

  createPlan: async (payload: CreateVisitasPlanDto): Promise<VisitasPlanDto> => {
    const response = await api.post<VisitasPlanDto>('/api/VisitasPlan', payload);
    return response.data;
  },

  updatePlan: async (id: number, payload: UpdateVisitasPlanDto): Promise<void> => {
    await api.put(`/api/VisitasPlan/${id}`, payload);
  },

  deletePlan: async (id: number): Promise<void> => {
    await api.delete(`/api/VisitasPlan/${id}`);
  },

  addVisitaToPlan: async (id: number, payload: CreateVisitasDto): Promise<VisitasDto> => {
    const response = await api.post<VisitasDto>(`/api/VisitasPlan/${id}/visitas`, payload);
    return response.data;
  },

  reordenarPendientes: async (id: number, payload: ReordenarVisitasPlanDto): Promise<void> => {
    await api.put(`/api/VisitasPlan/${id}/reordenar`, payload);
  },

  deleteVisitasPendientes: async (id: number): Promise<{ eliminadas: number }> => {
    const response = await api.delete<{ eliminadas: number }>(
      `/api/VisitasPlan/${id}/visitas-pendientes`,
    );
    return response.data;
  },
};

export default visitasPlanService;
